import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import ReviewStars from "../modules/ReviewStars";

export default function ReviewsAggregate({ data }) {
  const [allReviews, setAllReviews] = useState([]);
  const [totalReviewCount, setTotalReviewCount] = useState(0);
  const [averageStars, setAverageStars] = useState(0);
  const url =
    "//api.bazaarvoice.com/data/products.json?apiversion=5.4&passkey=ca6qyfDLykRniMh4RUK54h1OR23zYQSBtrzBvnPZ5ilGU&stats=reviews&filter=totalreviewcount:gte:1&excludeFamily=true&limit=100";
  const { heading, subheading } = data;

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((res) => setAllReviews(res.Results));
  }, []);

  useEffect(() => {
    if (allReviews.length) {
      getAverageReviews(allReviews);
    }
  }, [allReviews]);

  const getAverageReviews = (reviews) => {
    let reviewsTotal = 0;
    let starsTotal = 0;
    reviews.forEach((review) => {
      reviewsTotal += review.ReviewStatistics.TotalReviewCount;
      review.ReviewStatistics.RatingDistribution.forEach((rev) => {
        starsTotal += rev.RatingValue * rev.Count;
      });
    });
    const average = starsTotal / reviewsTotal;
    setAverageStars(average.toFixed(1));
    setTotalReviewCount(reviewsTotal);
  };

  return (
    <section className="hds-container bg-white pt-10 hds-text-color z-10">
      <div className="hds-section-sm">
        <div className="mx-auto max-w-3xl text-center z-10 relative">
          <h4 className="hds-title__medium mb-xs md:mb-sm font-bold font-heading bold-color">
            {heading}
          </h4>
          <p className="md:px-xs">{subheading}</p>
          <div className="flex justify-center items-center relative rounded pt-8 mx-auto -mb-10">
            <div className="homepage-stars-container ease-out duration-300 ml-4">
              <ReviewStars
                rating={averageStars - 0.1}
                starSize="54px"
                starSpacing="16px"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-0 lg:gap-10 z-10 relative mt-12">
          <div className="flex flex-col text-center p-6 rounded-md relative z-0 hds-transition stagger-item stagger-up is-showing">
            <h6 className="text-6xl sm:text-5xl lg:text-6xl font-bold leading-none font-heading text-primary uppercase gradient-text">
              {averageStars}
            </h6>
            <p className="flex-1 pt-1 leading-tight">Star Ratings</p>
          </div>
          <div className="flex flex-col text-center p-6 rounded-md relative z-0 hds-transition stagger-item stagger-up is-showing">
            <h6 className="text-6xl sm:text-5xl lg:text-6xl font-bold leading-none font-heading text-primary uppercase gradient-text">
              {totalReviewCount.toLocaleString()}
            </h6>
            <p className="flex-1 pt-1 leading-tight">Real User Reviews</p>
          </div>
          <div className="flex flex-col text-center p-6 rounded-md relative z-0 hds-transition stagger-item stagger-up is-showing">
            <h6 className="text-6xl sm:text-5xl lg:text-6xl font-bold leading-none font-heading text-primary uppercase gradient-text">
              100%
            </h6>
            <p className="flex-1 pt-1 leading-tight">Satisfaction Guaranteed</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export const reviewsQuery = graphql`
  fragment ReviewsAggregate on DatoCmsReviewsAggregate {
    id
    subheading
    heading
    internal {
      type
    }
  }
`;
